/* Galería a pantalla completa de la ficha de producto (Collar Cruz de Fe).
   Sin dependencias externas. Este archivo solo se carga en la sección
   mt-producto.liquid (no en el resto de la tienda) y se inicializa una
   única vez por carga de página. */
(function () {
  'use strict';

  var ESCALA_MAX = 3.5;
  var ESCALA_DOBLE_TOQUE = 2.5;
  var UMBRAL_DOBLE_TOQUE_MS = 300;
  var UMBRAL_DOBLE_TOQUE_PX = 30;

  function clamp(valor, min, max) {
    return Math.max(min, Math.min(max, valor));
  }

  function prefiereMovimientoReducido() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function esPuntero() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function init() {
    var lightbox = document.querySelector('[data-mt-lightbox]');
    var galeriaCerrada = document.querySelector('[data-mt-galeria]');
    if (!lightbox || !galeriaCerrada) return;

    var pista = lightbox.querySelector('[data-mt-lightbox-pista]');
    var contador = lightbox.querySelector('[data-mt-lightbox-contador]');
    var botonCerrar = lightbox.querySelector('[data-mt-lightbox-cerrar]');
    var flechaPrev = lightbox.querySelector('[data-mt-lightbox-prev]');
    var flechaNext = lightbox.querySelector('[data-mt-lightbox-next]');
    var principalCerrada = galeriaCerrada.querySelector('.mt-galeria__principal');

    var nodosSlide = lightbox.querySelectorAll('[data-mt-lightbox-slide]');
    var slides = [];
    nodosSlide.forEach(function (nodo) {
      slides.push({
        contenedor: nodo,
        zoomEl: nodo.querySelector('[data-mt-lightbox-zoom]'),
        img: nodo.querySelector('img'),
        cargado: false,
        escala: 1,
        panX: 0,
        panY: 0
      });
    });
    var total = slides.length;

    var indiceActual = 0;
    var elementoQueAbrio = null;
    var scrollYGuardado = 0;
    var abierta = false;
    var barraFija = document.querySelector('[data-mt-barra-fija]');
    var estiloBarraFijaPrevio = '';

    /* ---------- Datos de origen (misma fuente que la galería cerrada) ---------- */
    function datosSlot(indice) {
      var img = galeriaCerrada.querySelector('[data-mt-slot="' + indice + '"]');
      if (!img) return null;
      return { src: img.dataset.zoom || img.src, alt: img.alt };
    }

    /* ---------- Carga perezosa: actual + adyacentes únicamente ---------- */
    function cargarSlide(indice) {
      if (indice < 0 || indice >= total) return;
      var s = slides[indice];
      if (s.cargado) return;
      var datos = datosSlot(indice);
      if (!datos || !datos.src) return;
      s.img.src = datos.src;
      s.img.alt = datos.alt || '';
      s.cargado = true;
    }

    function prepararAdyacentes(indice) {
      cargarSlide(indice);
      cargarSlide(indice - 1);
      cargarSlide(indice + 1);
    }

    /* ---------- Zoom / paneo por slide ---------- */
    function aplicarTransform(s) {
      s.zoomEl.style.transform = 'translate(' + s.panX + 'px,' + s.panY + 'px) scale(' + s.escala + ')';
      s.zoomEl.classList.toggle('mt-zoom-activo', s.escala > 1.02);
    }

    function limitarPan(s) {
      var contRect = s.contenedor.getBoundingClientRect();
      var baseW = s.img.offsetWidth;
      var baseH = s.img.offsetHeight;
      var maxX = Math.max(0, (baseW * s.escala - contRect.width) / 2);
      var maxY = Math.max(0, (baseH * s.escala - contRect.height) / 2);
      s.panX = clamp(s.panX, -maxX, maxX);
      s.panY = clamp(s.panY, -maxY, maxY);
    }

    function resetearZoom(s) {
      s.escala = 1;
      s.panX = 0;
      s.panY = 0;
      aplicarTransform(s);
    }

    function alternarZoom(s) {
      if (s.escala > 1.02) {
        resetearZoom(s);
      } else {
        s.escala = ESCALA_DOBLE_TOQUE;
        s.panX = 0;
        s.panY = 0;
        limitarPan(s);
        aplicarTransform(s);
      }
    }

    function distanciaEntre(t1, t2) {
      var dx = t2.clientX - t1.clientX;
      var dy = t2.clientY - t1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function initGestosSlide(s) {
      var pinchInicial = null;
      var arrastreInicial = null;
      var ultimoToqueTiempo = 0;
      var ultimoToqueX = 0;
      var ultimoToqueY = 0;

      s.zoomEl.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          pinchInicial = { dist: distanciaEntre(e.touches[0], e.touches[1]), escala: s.escala };
          arrastreInicial = null;
        } else if (e.touches.length === 1) {
          if (s.escala > 1.02) {
            arrastreInicial = { x: e.touches[0].clientX, y: e.touches[0].clientY, panX: s.panX, panY: s.panY };
          }
          var ahora = Date.now();
          var t = e.touches[0];
          if (
            ahora - ultimoToqueTiempo < UMBRAL_DOBLE_TOQUE_MS &&
            Math.abs(t.clientX - ultimoToqueX) < UMBRAL_DOBLE_TOQUE_PX &&
            Math.abs(t.clientY - ultimoToqueY) < UMBRAL_DOBLE_TOQUE_PX
          ) {
            alternarZoom(s);
            ultimoToqueTiempo = 0;
          } else {
            ultimoToqueTiempo = ahora;
            ultimoToqueX = t.clientX;
            ultimoToqueY = t.clientY;
          }
        }
      }, { passive: true });

      s.zoomEl.addEventListener('touchmove', function (e) {
        if (e.touches.length === 2 && pinchInicial) {
          e.preventDefault();
          var d = distanciaEntre(e.touches[0], e.touches[1]);
          s.escala = clamp(pinchInicial.escala * (d / pinchInicial.dist), 1, ESCALA_MAX);
          limitarPan(s);
          aplicarTransform(s);
        } else if (e.touches.length === 1 && arrastreInicial) {
          e.preventDefault();
          s.panX = arrastreInicial.panX + (e.touches[0].clientX - arrastreInicial.x);
          s.panY = arrastreInicial.panY + (e.touches[0].clientY - arrastreInicial.y);
          limitarPan(s);
          aplicarTransform(s);
        }
      }, { passive: false });

      function finDeToques(e) {
        if (e.touches.length === 0) {
          pinchInicial = null;
          arrastreInicial = null;
          if (s.escala <= 1.02) resetearZoom(s);
        } else if (e.touches.length === 1) {
          pinchInicial = null;
          if (s.escala > 1.02) {
            arrastreInicial = { x: e.touches[0].clientX, y: e.touches[0].clientY, panX: s.panX, panY: s.panY };
          }
        }
      }
      s.zoomEl.addEventListener('touchend', finDeToques);
      s.zoomEl.addEventListener('touchcancel', finDeToques);

      /* Escritorio: doble clic para alternar zoom, rueda para ajustar */
      s.zoomEl.addEventListener('dblclick', function (e) {
        e.preventDefault();
        alternarZoom(s);
      });

      s.zoomEl.addEventListener('wheel', function (e) {
        if (!esPuntero()) return;
        e.preventDefault();
        var delta = e.deltaY < 0 ? 0.15 : -0.15;
        var nueva = clamp(s.escala + delta, 1, ESCALA_MAX);
        if (nueva === s.escala) return;
        s.escala = nueva;
        limitarPan(s);
        aplicarTransform(s);
      }, { passive: false });

      /* Escritorio: arrastrar con el ratón para desplazar cuando hay zoom */
      var arrastrandoRaton = false;
      var inicioRaton = null;
      s.zoomEl.addEventListener('mousedown', function (e) {
        if (s.escala <= 1.02) return;
        arrastrandoRaton = true;
        inicioRaton = { x: e.clientX, y: e.clientY, panX: s.panX, panY: s.panY };
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!arrastrandoRaton || !inicioRaton) return;
        s.panX = inicioRaton.panX + (e.clientX - inicioRaton.x);
        s.panY = inicioRaton.panY + (e.clientY - inicioRaton.y);
        limitarPan(s);
        aplicarTransform(s);
      });
      window.addEventListener('mouseup', function () {
        arrastrandoRaton = false;
        inicioRaton = null;
      });
    }

    slides.forEach(initGestosSlide);

    /* ---------- Navegación entre fotos ---------- */
    function actualizarContador() {
      contador.textContent = (indiceActual + 1) + ' / ' + total;
    }

    function actualizarFlechas() {
      if (flechaPrev) flechaPrev.disabled = indiceActual === 0;
      if (flechaNext) flechaNext.disabled = indiceActual === total - 1;
    }

    function irA(indice, instantaneo) {
      indice = clamp(indice, 0, total - 1);
      if (indice !== indiceActual) resetearZoom(slides[indiceActual]);
      indiceActual = indice;
      resetearZoom(slides[indiceActual]);
      prepararAdyacentes(indice);
      var comportamiento = instantaneo || prefiereMovimientoReducido() ? 'auto' : 'smooth';
      pista.scrollTo({ left: indice * pista.clientWidth, behavior: comportamiento });
      actualizarContador();
      actualizarFlechas();
    }

    var sincroniaPendiente = null;
    function sincronizarConScroll() {
      var ancho = pista.clientWidth;
      if (!ancho) return;
      var nuevoIndice = clamp(Math.round(pista.scrollLeft / ancho), 0, total - 1);
      if (nuevoIndice !== indiceActual) {
        resetearZoom(slides[indiceActual]);
        indiceActual = nuevoIndice;
        resetearZoom(slides[indiceActual]);
        prepararAdyacentes(indiceActual);
        actualizarContador();
        actualizarFlechas();
      }
    }
    pista.addEventListener('scroll', function () {
      if (sincroniaPendiente) clearTimeout(sincroniaPendiente);
      sincroniaPendiente = setTimeout(function () {
        sincroniaPendiente = null;
        sincronizarConScroll();
      }, 60);
    }, { passive: true });

    if (flechaPrev) flechaPrev.addEventListener('click', function () { irA(indiceActual - 1); });
    if (flechaNext) flechaNext.addEventListener('click', function () { irA(indiceActual + 1); });

    /* ---------- Apertura / cierre ---------- */
    function indiceVisibleActual() {
      var activo = galeriaCerrada.querySelector('.mt-galeria__principal img.mt-activa');
      return activo ? parseInt(activo.dataset.mtSlot, 10) || 0 : 0;
    }

    function bloquearScrollPagina() {
      scrollYGuardado = window.scrollY || window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = (-scrollYGuardado) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function restaurarScrollPagina() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollYGuardado);
    }

    function ocultarBarraFija() {
      if (!barraFija) return;
      estiloBarraFijaPrevio = barraFija.style.display;
      barraFija.style.display = 'none';
    }

    function mostrarBarraFija() {
      if (!barraFija) return;
      barraFija.style.display = estiloBarraFijaPrevio;
    }

    function sincronizarGaleriaCerrada() {
      var mini = galeriaCerrada.querySelector('[data-mt-mini="' + indiceActual + '"]');
      if (mini && !mini.classList.contains('mt-activa')) mini.click();
    }

    function mantenerFocoDentro(e) {
      if (!abierta) return;
      if (!lightbox.contains(e.target)) {
        e.stopPropagation();
        botonCerrar.focus();
      }
    }

    function onKeydown(e) {
      if (!abierta) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        cerrar();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        irA(indiceActual - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        irA(indiceActual + 1);
      }
    }

    function abrir(indiceInicial) {
      if (abierta) return;
      abierta = true;
      elementoQueAbrio = document.activeElement;

      slides.forEach(function (s) { s.cargado = false; resetearZoom(s); });

      lightbox.hidden = false;
      bloquearScrollPagina();
      ocultarBarraFija();
      document.addEventListener('focusin', mantenerFocoDentro, true);
      document.addEventListener('keydown', onKeydown);
      window.addEventListener('resize', onResize);

      irA(indiceInicial, true);
      botonCerrar.focus();
    }

    function cerrar() {
      if (!abierta) return;
      abierta = false;
      lightbox.hidden = true;
      restaurarScrollPagina();
      mostrarBarraFija();
      document.removeEventListener('focusin', mantenerFocoDentro, true);
      document.removeEventListener('keydown', onKeydown);
      window.removeEventListener('resize', onResize);

      sincronizarGaleriaCerrada();
      slides.forEach(resetearZoom);

      if (elementoQueAbrio && typeof elementoQueAbrio.focus === 'function') {
        elementoQueAbrio.focus();
      }
    }

    var reajusteTimeout = null;
    function onResize() {
      if (reajusteTimeout) clearTimeout(reajusteTimeout);
      reajusteTimeout = setTimeout(function () {
        slides.forEach(resetearZoom);
        irA(indiceActual, true);
      }, 120);
    }

    principalCerrada.addEventListener('click', function () {
      abrir(indiceVisibleActual());
    });

    botonCerrar.addEventListener('click', cerrar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
